import { render, staticRenderFns } from "./addReportCustom.vue?vue&type=template&id=20f63934"
import script from "./addReportCustom.vue?vue&type=script&lang=js"
export * from "./addReportCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports